import { datadogRum } from '@datadog/browser-rum';

const initializeDatadogRum = () => {
    if (process.env.NEXT_PUBLIC_DATADOG_RUM_ENABLED) {
        datadogRum.init({
            applicationId: '574f13e1-dfcf-42c2-931c-59474182d910',
            clientToken: 'pubf0178e9001c07ac9693e5ba1478ef482',
            site: 'datadoghq.com',
            service: 'marketing',
            env: 'prod',
            // Specify a version number to identify the deployed version of your application in Datadog
            version: '1.0.0',
            sampleRate: 3,
            // track 100% of sessions as Browser RUM
            replaySampleRate: 0,
            trackInteractions: true,
            defaultPrivacyLevel: 'mask-user-input',
        });
        datadogRum.startSessionReplayRecording();
    }
};

export default initializeDatadogRum;
